module.exports = __webpack_public_path__ + "assets/voucher-canceled-icon-b850ec.svg";